import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect, useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import "./assets/Styles/Style.css";

import Home from "./Pages/Home";
// Disabled pages - re-enable the import together with the route below:
// import EnrolmentPolicy from "./Pages/EnrolmentPolicy";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ScrollToTop from "./Components/ScrollToTop";
import BackToTop from "./Components/BackToTop";
import Commingsoon from "./Pages/Commingsoon";
// import WSPastPaper from "./Pages/WSPastPaper";
import TamilAnthem from "./Pages/TamilAntham";
import PageLoader from "./Components/PageLoader";
// import StripePaymentPage from "./Pages/Payment";
import ExpressionInterestForm from "./Pages/ExpressionInterestForm";
// import DinnerNight from "./Pages/DinnerNight";
import EventDetails from "./Pages/EventDetails";
import TamilClassesSydney from "./Pages/TamilClassesSydney";
import TamilClassesTa from "./Pages/TamilClassesTa";
import { TAMIL_PAGES_REVIEWED } from "./seo/pages.js";
import Programs from "./Pages/Programs";
import Enrolment from "./Pages/Enrolment";
import Contact from "./Pages/Contact";
import About from "./Pages/About";
import Events from "./Pages/Events";
import NotFound from "./Pages/NotFound";
import Donate from "./Pages/Donate";
import DonateThanks from "./Pages/DonateThanks";
import { listenForContactClicks } from "./utils/analytics.js";

function AppContent() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => listenForContactClicks(), []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tamil-classes-sydney" element={<TamilClassesSydney />} />
        {/* Tamil page: dev-only draft until a reviewer approves it (src/seo/pages.js) */}
        {(TAMIL_PAGES_REVIEWED || import.meta.env.DEV) && (
          <Route path="/ta/tamil-classes-sydney" element={<TamilClassesTa />} />
        )}
        <Route path="/programs" element={<Programs />} />
        <Route path="/enrolment" element={<Enrolment />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/events" element={<Events />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/donate/thank-you" element={<DonateThanks />} />
        {/* <Route path="/western-sydney-past-paper" element={<WSPastPaper />} /> */}
        <Route path="/tamil-anthem" element={<TamilAnthem />} />
        <Route path="/coming-soon" element={<Commingsoon />} />
        <Route path="/events/:slug" element={<EventDetails />} />
        <Route path="/eoi" element={<ExpressionInterestForm />} />
        {/* <Route path="/conditions-of-enrolment" element={<EnrolmentPolicy />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
      <Footer />
      <BackToTop />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
